import React from 'react';

// Person information component
export const PersonInfo = React.memo(({ person, title, odsCode }) => (
  <div className="document-person-info">
    <div className="info-row">
      <span className="label">Name:</span>
      <span className="value">{person.name || ''}</span>
    </div>
    <div className="info-row">
      <span className="label">Organisation:</span>
      <span className="value">{person.organisation || ''}</span>
    </div>
    <div className="info-row">
      <span className="label">Email:</span>
      <span className="value">{person.email || ''}</span>
    </div>
    {title === "Sender" && (
      <div className="info-row">
        <span className="label">Specialty:</span>
        <span className="value">{person.specialty || ''}</span>
      </div>
    )}
    {title === "Sender" && odsCode && (
      <div className="info-row">
        <span className="label">ODS Code:</span>
        <span className="value">{odsCode}</span>
      </div>
    )}
    <div className="info-row">
      <span className="label">Address:</span>
      <span className="value">
        {(person.address || '').split(', ').map((line, index) => (
          <div key={index} className="address-line">{line}</div>
        ))}
      </span>
    </div>
    <div className="info-row">
      <span className="label">Phone Number:</span>
      <span className="value">{person.phoneNumber || ''}</span>
    </div>
  </div>
)); 